import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CarrierPortalGlobalStoreProvider } from './components/stores/carrier-portal-global-store';
import Auth0ProviderWithRedirectCallback from './components/auth0/auth0-provider-with-redirect-callback';

declare global {
  interface Window {
    gbl_Modules: any;
    gbl_service_urls: any;
    gbl_ui_urls: any;
    auth0_settings: {
      domain: string;
      clientId: string;
      audience: string;
    };
  }
}

// Runtime config from /assets/auth0-settings.js (loaded by index.html before
// the bundle); deployed environments mount their own copy of that file over
// the image's baked default rather than compiling values into the build.
const auth0Config = window.auth0_settings;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CarrierPortalGlobalStoreProvider>
        <Auth0ProviderWithRedirectCallback
          cacheLocation="localstorage"
          domain={auth0Config.domain}
          clientId={auth0Config.clientId}
          skipRedirectCallback={
            window.location.pathname === '/stripe-oauth-callback'
          }
          authorizationParams={{
            audience: auth0Config.audience,
            scope: 'profile email read:users ',
            redirect_uri: window.location.origin
          }}
        >
          <App />
        </Auth0ProviderWithRedirectCallback>
      </CarrierPortalGlobalStoreProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
